// extracted by css-extract-rspack-plugin
export default {"backdrop":"MV1Baog3IqApNfUm","main":"rng2K5rMcZEyLyR6","resultsContainer":"GrsMwWkURucn8EgX"};